import Nav from "../components/Nav";
import { useTranslation } from "../i18n/LanguageContext";

function ErrorPage()    {
    const { t } = useTranslation();
    return <>
        <Nav />
        {t("error.message")}
    </>
}

export default ErrorPage;
